import {NotFoundInfo} from './NotFoundInfo';
export default NotFoundInfo;
